<template>
  <div class="site-page site-page--wide nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">联系我们</h1>
      <el-row :gutter="20" class="site-page__grid-row">
        <el-col :xs="24" :md="10">
          <div class="site-page__card site-page__card--muted">
            <h2 class="site-page__section-title">联系方式</h2>
            <div class="site-page__info-list">
              <div class="site-page__info-item">
                <el-icon><Location /></el-icon>
                <span>广东省深圳市南山区</span>
              </div>
              <div class="site-page__info-item">
                <el-icon><Phone /></el-icon>
                <span>15622302051</span>
              </div>
              <div class="site-page__info-item">
                <el-icon><Message /></el-icon>
                <span>contact@coolpeople.com.cn</span>
              </div>
            </div>
            <div class="site-page__social">
              <el-link :href="social.github" target="_blank" rel="noopener noreferrer">
                <el-icon><Link /></el-icon>
              </el-link>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :md="14">
          <div class="site-page__card">
            <el-form
              ref="contactForm"
              :model="contactForm"
              :rules="rules"
              label-position="top"
              class="site-page__form"
            >
              <el-form-item label="称呼" prop="name">
                <el-input v-model="contactForm.name" placeholder="您的称呼" />
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="contactForm.email" placeholder="您的邮箱" />
              </el-form-item>
              <el-form-item label="主题" prop="subject">
                <el-input v-model="contactForm.subject" placeholder="留言主题" />
              </el-form-item>
              <el-form-item label="留言" prop="message">
                <el-input
                  v-model="contactForm.message"
                  type="textarea"
                  :rows="6"
                  placeholder="请输入留言内容"
                />
              </el-form-item>
              <el-form-item>
                <div class="site-page__form-actions">
                  <el-button type="primary" @click="submitForm">发送</el-button>
                  <el-button @click="resetForm">重置</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Location, Phone, Message, Link } from '@element-plus/icons-vue'

export default {
  name: 'ContactView',
  components: {
    Location,
    Phone,
    Message,
    Link
  },
  data() {
    return {
      contactForm: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      rules: {
        name: [{ required: true, message: '请输入称呼', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        subject: [{ required: true, message: '请输入主题', trigger: 'blur' }],
        message: [{ required: true, message: '请输入留言', trigger: 'blur' }]
      },
      social: {
        github: 'https://github.com'
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          this.$message.success('留言已提交，我们会尽快回复您！')
          this.resetForm()
        }
      })
    },
    resetForm() {
      this.$refs.contactForm.resetFields()
    }
  }
}
</script>
